<template>
  <IconLucidePause />
</template>
